module.exports = __webpack_public_path__ + "static/media/bg_downgrade_suggestion_from_40_to_44.651e14ad.webp";